export { default as useLocalStorage } from "./useLocalStorage";

export const arrayEquals = (a:any[], b:any[]):boolean => JSON.stringify(a) === JSON.stringify(b);

export const childrenCompare = (a:any[], b:any[]):boolean => {
  let equals = true;

  function ck(base:any[],search:any[]):boolean{
    let equals = true;
    base.forEach((name: string)=>{
      if(search.indexOf(name) === -1){
        equals = false;
      }
    })
    return equals;
  }

  function cv(a:any,b:any):boolean{
    let equals = true;
    let a_p = Object.keys(a); 
    a_p.forEach((name)=>{
      if(name !== "_owner" && name !== "_store"){
        let a_v = a[name];
        let b_v = b[name];
        if(a_v instanceof Function){
          if(a_v.toString() !== b_v.toString()){
            equals = false;
          }          
        } else if(a_v instanceof Object){
          if(!co(a_v,b_v)){
            equals = false;
          }
        } else {
          if(a_v !== b_v){
            equals = false;
          }
        }
      }
    });
    return equals;
  }

  function co(a:any, b:any):boolean{
    let equals = true;
  
  
    if(a && b){
      let a_p = Object.keys(a); 
      let b_p = Object.keys(b);
      if(a_p.length === b_p.length){
        if(ck(a_p,b_p) && ck(b_p,a_p)){
          if(!cv(a,b)){
            equals = false;
          }
        } else {
          equals = false;
        }
      } else {
        equals = false;
      }
  
    } else if(!(!a && !b)){
      equals = false;
    }
  
    return equals;
  };

  if(a && b){
    if(a instanceof Array && b instanceof Array){
      a.forEach((item,key)=>{
        if(!co(item,b[key])){
          equals = false;
        }
      });
    } else {
      if(!co(a,b)){
        equals = false;
      }
    }
  } else if(!(!a && !b)){
    equals = false;
  }
  return equals;
}

export const getInfoElement = (e: HTMLElement) => {
  let r = e.getBoundingClientRect();
  return {
    x: r.left,
    y: r.top,
    width: r.right - r.left,
    height: r.bottom - r.top
  }
}

export const mouseEnterElement = (e: HTMLElement, event: MouseEvent) => {
  let mx = event.clientX;
  let my = event.clientY;

  let r = e.getBoundingClientRect();
  if(r.left < mx && mx < r.right){
    if(r.top < my && my < r.bottom){
      return true;
    }
  }
  return false;
}

export function str_shuffle(str: string){
  var a = str.split(""),n = a.length;

  for(var i = n - 1; i > 0; i--) {
    var j = Math.floor(Math.random() * (i + 1));
    var tmp = a[i];
    if(Math.floor(Math.random()*2)){
      tmp = tmp.toUpperCase();
    }
    a[i] = a[j];
    a[j] = tmp;
  }
  return a.join("");
}

export function getColorByMail(email:string){
  const alphabet = 'abcdefghijklmnopqrstuvwxyz'.split('');
  
  function getInt(c:string){
    let n = (c.charCodeAt(0)-97)*(255/alphabet.length);
    if(n<0) n = 0;
    if(n>200) n = 200;
    return n;
  }

  // function shuffle(p:string){
  //   try {
  //     let l = p.split("").sort();
  //     let laux = [...l];
  //     let index = parseInt((p.length/2).toString());
      
  //     for (let i = 0; i < l.length; i++) {
  //       let aux = laux[index];
  //       laux[index] = laux[i];
  //       laux[i] = aux;
  //       index += (index+i)%l.length;
  //     }
  
  //     return laux.join("");
  //   } catch (error) {
  //     return "error"
      
  //   }
  // }

  let alp_index = (email+email).length;
  
  function getAlp(){
    if(alp_index >= alphabet.length){
      alp_index = alp_index % alphabet.length;
    }
    let r = alphabet[alp_index];
    alp_index += 2;
    return r;
  }

  let [p1,p2] = email.toLowerCase().split('@');
  p2 += p1;

  if(p1.length < 6){
    for (let i = 0; i < 6; i++) {
      if(i%2===0) p1 = getAlp()+p1;
      else p1 += getAlp();
    }
  }
  if(p2.length < 6){
    for (let i = 0; i < 6; i++) {
      if(i%2===0) p2 = getAlp()+p2;
      else p2 += getAlp();
    }
  }

  while(p1.length % 3 !== 0){
    if(p1.length%2===0) p1 = getAlp()+p1;
    else p1 += getAlp();
  }
  while(p2.length % 3 !== 0){
    if(p2.length%2===0) p2 = getAlp()+p2;
    else p2 += getAlp();
  }
  if(p1.length !== p2.length){
    while(p1.length > p2.length){
      if(p2.length%2===0) p2 = getAlp()+p2;
      else p2 += getAlp();
    }
    while(p2.length > p1.length){
      if(p1.length%2===0) p1 = getAlp()+p1;
      else p1 += getAlp();
    }
  }
  
  let [r,g,b] = [0,0,0];
  let div = 0;
  for (let i = 0; i < p2.length; i+=3) {
    div+=2;
    r += getInt(p1[i])+getInt(p2[i]);
    g += getInt(p1[i+1])+getInt(p2[i+1]);
    b += getInt(p1[i+2])+getInt(p2[i+2]);
  }

  r = parseInt((r/div).toString());
  g = parseInt((g/div).toString());
  b = parseInt((b/div).toString());

  if(r < g && r < b){
    if(g>b)
      g = parseInt(((g+((g+255)/3))/2).toString());
    else
      b = parseInt(((b+((b+255)/3))/2).toString());
    r = parseInt((r/2).toString());
  } else if(g < b && g < r){
    if(r>b)
      r = parseInt(((r+((r+255)/3))/2).toString());
    else
      b = parseInt(((b+((b+255)/3))/2).toString());
    g = parseInt((g/2).toString());
  } else if(b < g && b < r){
    if(r>g)
      r = parseInt(((r+((r+255)/3))/2).toString());
    else
      g = parseInt(((g+((g+255)/3))/2).toString());
    b = parseInt((b/2).toString());
  }
  
  return {
    r: r,
    g: g,
    b: b,
    a: 255,
    hex: `#${r.toString(16)}${g.toString(16)}${b.toString(16)}ff`
  };
}